import { useMemo } from "react";

import type { CryptoAsset } from "~/v2/api/rest/cryptoWallet";
import { getTokenizedEquityMarketDataSymbol } from "~/v2/helpers/tokenizedEquityTrading";
import {
  cryptoAssetSymbolToAssetSymbol,
  cryptoAssetSymbolToQuoteSymbol,
} from "../util";

export interface CryptoTransferSymbols {
  walletSymbol: string;
  quoteSymbol: string;
  positionSymbol: string;
  chain: string;
  assetCode: string;
}

export const getCryptoTransferSymbols = (
  asset: CryptoAsset | null,
): CryptoTransferSymbols => {
  const walletSymbol = asset?.symbol ?? "";
  const tokenizedMarketDataSymbol = walletSymbol
    ? getTokenizedEquityMarketDataSymbol(walletSymbol)
    : undefined;

  return {
    walletSymbol,
    quoteSymbol:
      tokenizedMarketDataSymbol ??
      (walletSymbol ? cryptoAssetSymbolToQuoteSymbol(walletSymbol) : ""),
    positionSymbol:
      tokenizedMarketDataSymbol ??
      (walletSymbol ? cryptoAssetSymbolToAssetSymbol(walletSymbol) : ""),
    chain: asset?.chain?.chain ?? "",
    assetCode: asset?.asset ?? "",
  };
};

export const useCryptoTransferSymbols = (
  asset: CryptoAsset | null,
): CryptoTransferSymbols =>
  useMemo(() => getCryptoTransferSymbols(asset), [asset]);
